import { render, staticRenderFns } from "./GlossaryPreview.vue?vue&type=template&id=d3e96cfc&scoped=true&"
import script from "./GlossaryPreview.vue?vue&type=script&lang=ts&"
export * from "./GlossaryPreview.vue?vue&type=script&lang=ts&"
import style0 from "./GlossaryPreview.vue?vue&type=style&index=0&id=d3e96cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e96cfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VFadeTransition,VIcon})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
